import { call, put, takeEvery } from 'redux-saga/effects';
import { dealerActionCreators, DealerActionKeys, FetchDealerShipments } from '..';
import { IPagedResponse } from '../../apiInterfaces';
import { IShipmentListItem, logisticsActionCreators } from '../../logistics';
import * as api from '../dealerApi';

function* fetchDealerShipmentsSaga(action: FetchDealerShipments) {
  yield put(dealerActionCreators.toggleLoading({ accountNum: action.payload.accountNum, type: 'shipment' }));
  const response: IPagedResponse<IShipmentListItem> = yield call(api.fetchShipments, action.payload);

  yield put(logisticsActionCreators.fetchShipmentListFulfilled(response.items));
  yield put(dealerActionCreators.setShipments(action.payload.accountNum, response));
  yield put(dealerActionCreators.toggleLoading({ accountNum: action.payload.accountNum, type: 'shipment' }));
}

export function* watchFetchDealerShipments() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER_SHIPMENTS, fetchDealerShipmentsSaga);
}
